'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'

import { useInterval } from '@src/hooks/useInterval'
import { cn } from '@src/utils/tailwind'

import { textStyleMap } from '../Builder/Text/Text'
import { SlidingTextDefaultProps } from './SlidingText.defaults'

export interface SlidingTextProps {
  items: Array<{ value: string }>
  speed: number
  duration: number
  itemColor: string
  itemStyle: keyof typeof textStyleMap
}

export const SlidingText = (props: SlidingTextProps = SlidingTextDefaultProps) => {
  const { items, itemColor, itemStyle, speed, duration } = props
  const [index, setIndex] = useState(0)

  useInterval(
    () => {
      setIndex((state) => (state + 1) % items.length)
    },
    Number(duration) * 1000
  )

  return (
    <div className="relative text-center text-black">
      <div
        className={textStyleMap[itemStyle]}
        style={{ color: 'transparent' }}
        dangerouslySetInnerHTML={{ __html: items[0].value }}
      ></div>

      <AnimatePresence>
        <motion.div
          key={items[index].value}
          className="absolute top-0 left-0 flex w-full justify-center"
          initial={{ y: '-100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '100%', opacity: 0 }}
          transition={{
            y: { duration: speed },
            opacity: { duration: speed },
          }}
        >
          <div
            className={cn('text-center', textStyleMap[itemStyle])}
            style={{ color: itemColor }}
            dangerouslySetInnerHTML={{ __html: items[index].value }}
          ></div>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
